<template>
  <v-container fluid class="rbu-edition-detail" v-if="edition">
    <v-row class="flex-grow-0">
      <v-btn text color="primary" exact :to="{ name: 'rbu-edition-list' }">
        <h3 class="font-weight-regular">&lt;&lt; {{ $t("app_drawer.rbu") }}</h3>
      </v-btn>
    </v-row>

    <v-row
      v-if="canEditConfig"
      class="rbu-edition-info-wrapper"
      style="margin-bottom: 1rem"
    >
      <v-col>
        <h3>Configure: {{ edition.edition }}</h3>
      </v-col>
      <v-btn
        v-if="edition && !edition.updating_selected_rate"
        color="primary"
        @click="save"
        >Save
      </v-btn>
      <v-btn v-else color="primary" disabled
        >Updating Items: {{ edition.updated_item }}</v-btn
      >
    </v-row>

    <v-row v-else class="rbu-edition-info-wrapper" style="margin-bottom: 1rem">
    </v-row>

    <v-form>
      <v-text-field
        outlined
        type="text"
        :label="$t('rbu.rbu_edition_name')"
        v-model="edition.name"
        :rules="requiredRules"
        :disabled="
          (edition && edition.updating_selected_rate) || !canEditConfig
        "
      ></v-text-field>

      <!-- <RbuPeriodInput
        :label="$t('rbu.latest')"
        v-model="edition.latest"
        :rules="requiredRules"
      ></RbuPeriodInput> -->

      <v-select
        v-model="edition.selected_dataset"
        :items="dataset"
        chips
        label="Datasets"
        multiple
        outlined
        :disabled="
          (edition && edition.updating_selected_rate) || !canEditConfig
        "
      ></v-select>

      <RbuPeriodInput
        :label="$t('rbu.base_start')"
        v-model="edition.base_start"
        :rules="requiredRules"
        :disabled="
          (edition && edition.updating_selected_rate) || !canEditConfig
        "
        :min="min"
        :max="max"
      ></RbuPeriodInput>
      <RbuPeriodInput
        :label="$t('rbu.base_end')"
        v-model="edition.base_end"
        :rules="requiredRules"
        :disabled="
          (edition && edition.updating_selected_rate) || !canEditConfig
        "
        :min="min"
        :max="max"
      ></RbuPeriodInput>
      <!-- <v-text-field
        outlined
        type="number"
        min="0"
        step=".01"
        suffix="%"
        :label="$t('rbu.contract_percentage')"
        v-model="edition.contract_percentage"
        :rules="requiredRules"
      ></v-text-field> -->
      <v-text-field
        outlined
        type="number"
        min="0"
        step=".01"
        suffix="%"
        :label="$t('rbu.tcef')"
        v-model="edition.tcef"
        :rules="requiredRules"
        :disabled="
          (edition && edition.updating_selected_rate) || !canEditConfig
        "
      ></v-text-field>
      <v-text-field
        outlined
        type="number"
        min="0"
        step=".01"
        suffix="%"
        :label="$t('rbu.head_office_overhead_and_profit')"
        v-model="edition.head_office_overhead_and_profit"
        :rules="requiredRules"
        :disabled="
          (edition && edition.updating_selected_rate) || !canEditConfig
        "
      ></v-text-field>

      <!-- TODO -->
      <div style="border: 1px solid #737272; padding: 0.5rem" class="rounded">
        <span style="font-size: 0.75rem; color: #737272"
          >Cheaper Rate Enable</span
        >
        <div
          class=""
          style="display: flex; flex-direction: row; flex-wrap: wrap; gap: 1rem"
        >
          <v-checkbox
            v-model="edition.rbu_rate_for_cheaper_rate_enable"
            :label="'RBU Rate'"
            :disabled="
              (edition && edition.updating_selected_rate) || !canEditConfig
            "
          ></v-checkbox>

          <v-checkbox
            v-model="edition.tcef_for_cheaper_rate_enable"
            :label="'TCEF Rate'"
            :disabled="
              (edition && edition.updating_selected_rate) || !canEditConfig
            "
          ></v-checkbox>

          <v-checkbox
            v-model="edition.fluctuation_for_cheaper_rate_enable"
            :label="'Fluctuation Rate'"
            :disabled="
              (edition && edition.updating_selected_rate) || !canEditConfig
            "
          ></v-checkbox>
        </div>
      </div>
    </v-form>
  </v-container>
</template>
<script>
import { ACTION_TYPES } from "@/store/types";
import {
  onMounted,
  onUnmounted,
  ref,
  computed,
  watch,
} from "@vue/composition-api";
import RbuSectionList from "@/components/rbu/RbuSectionList.vue";
import RbuPeriodInput from "@/components/rbu/RbuPeriodInput.vue";
import { USER_TYPE } from "@/constants";

export default {
  name: "RbuEditionConfigure",
  components: { RbuPeriodInput, RbuSectionList },
  setup(props, { root }) {
    const min = ref(undefined);
    const max = ref(undefined);
    const dataset = ref([]);

    const requiredRules = ref([
      (value) => !!value || root.$t("rules.required"),
    ]);

    const edition = ref(null);
    const canEditConfig = computed(() => {
      if (!root.$store.getters.account) return false;
      return [USER_TYPE.SUPER_ADMIN, USER_TYPE.ADMIN].includes(
        root.$store.getters.account.type
      );
    });
    const getEdition = async function (force = false, not_blocking = true) {
      if (
        (edition.value && edition.value.updating_selected_rate === true) ||
        force
      ) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/rbu/edition/",
          params: { edition_id: root.$route.params.editionId, no_log: true },
          opt: { not_blocking },
        });

        if (response.body.success) {
          edition.value = response.body.edition;
          // edition.value.contract_percentage = parseFloat(
          //   edition.value.contract_percentage
          // ).toFixed(2);
          edition.value.tcef = parseFloat(edition.value.tcef).toFixed(2);
          edition.value.head_office_overhead_and_profit = parseFloat(
            edition.value.head_office_overhead_and_profit
          ).toFixed(2);
        }
      }
    };

    const getDataset = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/dataset/",
        params: {},
      });

      if (response && response.data && response.data.success) {
        dataset.value = response.data.datasets.map((d) => {
          return {
            text: `[${d.alias}]`,
            value: d.id,
          };
        });
      }
    };

    const getAvailablePeriod = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/dataset/available_data_period/",
        params: {
          datasets: edition.value.selected_dataset,
          no_log: true,
        },
      });

      if (response && response.data && response.data.success) {
        min.value = response.data.min;
        max.value = response.data.max;
      }
    };

    //
    const save = async function () {
      if (
        !edition.value.rbu_rate_for_cheaper_rate_enable &&
        !edition.value.tcef_for_cheaper_rate_enable &&
        !edition.value.fluctuation_for_cheaper_rate_enable
      ) {
        root.$store.dispatch(ACTION_TYPES.SHOW_SNACKBAR, {
          message: `Please select at least one options for Cheaper Rate Enable`,
        });
        return;
      }

      if (
        await root.$dialog.confirm({
          text: `Are you sure to update the master configure of [${edition.value.edition}] - [${edition.value.name}]?`,
        })
      ) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/rbu/edition/edit/",
          params: {
            edition_id: root.$route.params.editionId,
            ...edition.value,
          },
        });

        if (response.body.success) {
          if (response.body.failed) {
            let msg = "";
            response.body.failed.section_fluctuations.forEach((s) => {
              msg = msg + `Section ${s} Fluctuation\r\n`;
            });
            response.body.failed.items.forEach((i) => {
              msg = msg + `Item ${i}\r\n`;
            });

            if (msg.length > 0) {
              root.$store.dispatch(
                ACTION_TYPES.SHOW_SNACKBAR,
                `Failed to update:\r\n${msg}`
              );
            }
          }
          getEdition(true);
        }
      }
    };

    let refreshInterval = null;

    onMounted(() => {
      getEdition(true);
      getAvailablePeriod();
      getDataset();

      refreshInterval = setInterval(getEdition, 2500);
    });

    onUnmounted(() => {
      if (refreshInterval) {
        clearInterval(refreshInterval);
      }
    });

    watch(
      () => edition.value.selected_dataset,
      (newValue, _) => {
        getAvailablePeriod();
      }
    );

    return {
      requiredRules,
      canEditConfig,
      edition,

      save,
      min,
      max,
      dataset,
    };
  },
};
</script>

<style lang="less">
.rbu-edition-detail {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .rbu-edition-info-wrapper {
    flex: 0 0 auto;
    display: flex;

    .rbu-edition-info {
      flex: 1 1 0;
    }
  }
}
</style>
